export const countShowPropertyOnPage: number = 10;
